module.exports = __webpack_public_path__ + "img/water_shortage.c1dda565.svg";